import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Paper, Tabs, Tab, Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Checkbox, TextField } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { Navbar } from "./Navbar";
import Slider from "react-slick";
import "../../css/propertydetails.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Import marker images correctly
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

// Define custom icon
const customIcon = L.icon({
    iconUrl: new URL(markerIconPng, import.meta.url).href, // Correctly resolve path
    shadowUrl: new URL(markerShadowPng, import.meta.url).href,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

export const PropertyDetails = () => {

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [error, setError] = useState("");
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [propertyURL, setPropertyURL] = useState("");
    // Function to check if both fields are filled

    useEffect(() => {
        const url = window.location.href; // Get current page URL
        setPropertyURL(url);
        setIsButtonEnabled(!!url); // Enable button if URL exists
    }, []);

    const copyLink = () => {
        navigator.clipboard.writeText(propertyURL);
        alert("Link copied to clipboard!");
    };


    const { id, category } = useParams();
    const [property, setProperty] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [similarProperties, setSimilarProperties] = useState([]);
    const [popupMedia, setPopupMedia] = useState({ url: "", type: "" });
    const [tabValue, setTabValue] = useState(0);
    const navigate = useNavigate();

    const overviewRef = useRef(null);
    const projectRef = useRef(null);
    const furnishingRef = useRef(null);
    const amenitiesRef = useRef(null);
    const localityRef = useRef(null);
    const [activeTab, setActiveTab] = useState("Overview");

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };


    useEffect(() => {
        console.log(`Fetching property: Category = ${category}, ID = ${id}`);

        // Fetch property details
        axios.get(`/api/property/${category}/${id}`)
            .then((response) => {
                console.log("API Response:", response.data);
                const prop = response.data;

                // ✅ Extract image URLs from media array
                if (prop.media && prop.media.length > 0) {
                    prop.images = prop.media
                        .filter(m => m.type === "image")
                        .map(m => m.url);
                } else {
                    prop.images = [];
                }

                setProperty(prop);
            })
            .catch((error) => console.error("Error fetching property details:", error));

        // Fetch similar properties
        axios.get(`/api/similar/${category}/${id}`)
            .then((response) => {
                console.log("Similar API Response:", response.data);
                setSimilarProperties(response.data);
            })
            .catch((error) => console.error("Error fetching similar properties:", error));
    }, [id, category]);


    const handlePropertyClick = (propertyId, propertyCategory) => {
        // console.log(`/property/${propertyCategory}/${propertyId}`);
        // navigate(`/property/${propertyCategory}/${propertyId}`);
        // window.scrollTo(0, 0);
        window.location.href = `/property/${category}/${propertyId}`;
    };

    const handleGetContactDetails = async () => {


        const userName = document.getElementById("userName").value;
        const userPhone = document.getElementById("userPhone").value;

        console.log("Sending Lead Data:", {
            userName,
            userPhone,
            propertyId: property.postid,
            category: property.proptype,
            property: property.bpn,
            pincode: property.pincode,

        });

        if (!userName || !userPhone) {
            alert("Please enter your name and phone number.");
            return;
        }

        try {
            const response = await axios.post(`/api/create-lead`, {
                userName,
                userPhone,
                propertyId: property.postid,
                category: property.proptype,
                property: property.bpn,
                pincode: property.pincode,
                agentid: property.agent_id,

            });

            if (response.data.success) {
                window.open(response.data.whatsappLink, "_blank");
            } else {
                alert("Error processing request.");
            }
        } catch (error) {
            console.error("Error:", error);

            if (error.response) {
                // The request was made and the server responded with a status code
                console.log("Server Response:", error.response.data);
                console.log("Status Code:", error.response.status);
                console.log("Headers:", error.response.headers);
                alert(`Error: ${error.response.data.message || "Server error"}`);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("No Response received:", error.request);
                alert("No response from server. Check if the backend is running.");
            } else {
                // Something happened in setting up the request
                console.log("Request Error:", error.message);
                alert("Request setup error.");
            }
        }
    };

    if (!property) return <h2>Loading property details...</h2>;

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const openPopup = (media) => {
        setPopupMedia(media);
        setPopupOpen(true);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };
    const scrollToSection = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    return (
        <div>
            <Navbar />
            <div className="property-details-container">
                {/* Left Section */}
                <div className="property-left">

                    {/* Image & Video Slider */}
                    {property.media && property.media.length > 0 && (
                        <Slider {...settings} className="property-slider">
                            {property.media.map((media, index) => (
                                <div key={index} onClick={() => openPopup(media)}>
                                    {media.type === "image" ? (
                                        <img src={media.url} alt="Property" />
                                    ) : (
                                        <video controls >
                                            <source src={media.url} type="video/mp4" />
                                        </video>
                                    )}
                                </div>
                            ))}
                        </Slider>
                    )}

                    {/* Property Details */}
                    <Paper className="property-info">
                        <h2>{property.bpn} </h2>
                        <p><strong>Location:</strong><span className="ans"> {property.pinlocality}, {property.city}</span></p>
                        <p><strong>Price:</strong> <span className="ans"> ₹{property.cost}</span></p>
                        <p><strong>Area:</strong> <span className="ans"> {property.buitupareasq} sqft</span></p>

                        {/* Tabs for Different Sections */}
                        <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 2 }}>
                            <div className="property-tab-buttons sticky-tabs">
                                <button
                                    className={activeTab === "Overview" ? "active-tab" : ""}
                                    onClick={() => {
                                        scrollToSection(overviewRef);
                                        setActiveTab("Overview");
                                    }}
                                >
                                    Overview
                                </button>



                                {(property.furnishtype || property.flatfurnishings) && (
                                    <button
                                        className={activeTab === "Furnishings" ? "active-tab" : ""}
                                        onClick={() => {
                                            scrollToSection(furnishingRef);
                                            setActiveTab("Furnishings");
                                        }}
                                    >
                                        Furnishings
                                    </button>
                                )}

                                {(property.societyamenities || property.facilitiesoffered || property.securityamenities || property.services || property.topamenities) && (
                                    <button
                                        className={activeTab === "Amenities" ? "active-tab" : ""}
                                        onClick={() => {
                                            scrollToSection(amenitiesRef);
                                            setActiveTab("Amenities");
                                        }}
                                    >
                                        Amenities
                                    </button>
                                )}

                                <button
                                    className={activeTab === "Locality" ? "active-tab" : ""}
                                    onClick={() => {
                                        scrollToSection(localityRef);
                                        setActiveTab("Locality");
                                    }}
                                >
                                    Locality
                                </button>
                            </div>

                        </Box>

                        {/* Tab Content */}
                        <div ref={overviewRef} className="tab-section">
                            <h3>Overview</h3>
                            <div className="overview-grid">
                                {/* Project Name */}

                                {property.proptypename && (
                                    <p><span className="topic">Type:</span> <span className="value">{property.proptypename}</span></p>
                                )}
                                {property.bhk && (
                                    <p><span className="topic">BHK:</span> <span className="value">{property.bhk}</span></p>
                                )}
                                {/* Security */}
                                {property.securitydeposit && (
                                    <p><span className="topic">Security:</span> <span className="value">₹{property.securitydeposit}</span></p>
                                )}

                                {/* Brokerage */}
                                {property.brokeragcharge && (
                                    <p><span className="topic">Brokerage:</span> <span className="value">{property.brokeragcharge} (Negotiable)</span></p>
                                )}

                                {/* Built-up Area */}
                                {property.buitupareasq && (
                                    <p><span className="topic">Built-up Area:</span> <span className="value">{property.buitupareasq} sqft</span></p>
                                )}

                                {/* Furnishing */}
                                {property.furnishtype && (
                                    <p><span className="topic">Furnishing:</span> <span className="value">{property.furnishtype}</span></p>
                                )}

                                {/* Bathrooms */}
                                {property.bathroom && (
                                    <p><span className="topic">Bathrooms:</span> <span className="value">{property.bathroom}</span></p>
                                )}

                                {/* Balcony */}
                                {property.balcony && (
                                    <p><span className="topic">Balcony:</span> <span className="value">{property.balcony}</span></p>
                                )}

                                {/* Available from */}
                                {property.availablefrom && (
                                    <p><span className="topic">Available from:</span> <span className="value">{property.availablefrom}</span></p>
                                )}

                                {/* Floor Number */}
                                {property.floorno && property.totalfloor && (
                                    <p><span className="topic">Floor Number:</span> <span className="value">{property.floorno} of {property.totalfloor} floors</span></p>
                                )}

                                {/* Age of Property */}
                                {property.ageofproperty && (
                                    <p><span className="topic">Age of Property:</span> <span className="value">{property.ageofproperty}</span></p>
                                )}

                                {/* Private Parking */}
                                {property.privateparking && (
                                    <p><span className="topic">Private Parking:</span> <span className="value">{property.privateparking}</span></p>
                                )}

                                {/* Public Parking */}
                                {property.publicparking && (
                                    <p><span className="topic">Public Parking:</span> <span className="value">{property.publicparking}</span></p>
                                )}

                                {/* Price Negotiable */}
                                {property.price_negotiable !== undefined && (
                                    <p><span className="topic">Price Negotiable:</span> <span className="value">{property.price_negotiable ? "Yes" : "No"}</span></p>
                                )}
                            </div>

                        </div>




                        {(property.furnishtype || property.flatfurnishings) && (
                        <div ref={furnishingRef} className="tab-section">

                            <h3>Furnishing Details</h3>
                            {/* Display Furnish Type if available */}
                            {property.furnishtype && (
                                <p><strong>Furnish Type:</strong> {property.furnishtype}</p>
                            )}

                            {category.toLowerCase() === "residential" && property.flatfurnishings && (
                                <div className="furnishings-container">
                                    {/* Furnishings header */}
                                    <div className="furnishings-header">Furnishings in Property:</div>

                                    {/* Items Section */}
                                    <div className="furnishings-items">
                                        {property.flatfurnishings.split(',').map((furnishing, index) => (
                                            <div key={index} className="furnishings-box">
                                                {furnishing.trim()}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                        )}



                        {(property.societyamenities || property.facilitiesoffered || property.securityamenities || property.services || property.topamenities) && (
                        <div ref={amenitiesRef} className="tab-section">

                            <h3>Amenities</h3>
                            {category.toLowerCase() === "residential" ? (
                                <div className="amenities-container">
                                    {/* Split Society Amenities into individual boxes */}
                                    {property.societyamenities && property.societyamenities.split(',').map((item, index) => (
                                        <div className="amenities-box" key={index}>
                                            {item.trim()}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <ul>
                                    {property.suitablefor && (
                                        <li className="property-box">
                                            <h4>Suitable For:</h4>
                                            <p>{property.suitablefor}</p>
                                        </li>
                                    )}
                                    {property.addamenities && (
                                        <li className="property-box">
                                            <h4>Additional Amenities:</h4>
                                            <p>{property.addamenities}</p>
                                        </li>
                                    )}
                                    {property.zonetype && (
                                        <li className="property-box">
                                            <h4>Zone Type:</h4>
                                            <p>{property.zonetype}</p>
                                        </li>
                                    )}
                                </ul>
                            )}

                        </div>
                        )}


                        <div ref={localityRef} className="tab-section">
                            <div>
                                <h3>Locality</h3>
                                <p><strong>Address:</strong> {property.address}</p>
                                <p><strong>City:</strong> {property.city}</p>
                                <p><strong>State:</strong> {property.state}</p>
                                <p><strong>Pincode:</strong> {property.pincode}</p>



                                {property.latitude && property.longitude ? (
                                    <iframe
                                        title="Property Location"
                                        width="100%"
                                        height="300"
                                        style={{ border: "0", marginTop: "10px", borderRadius: "8px" }}
                                        src={`https://www.google.com/maps?q=${property.latitude},${property.longitude}&output=embed`}
                                        allowFullScreen
                                    ></iframe>
                                ) : (
                                    <p>Map not available for this address.</p>
                                )}
                            </div>
                        </div>

                    </Paper>

                    {/* ✅ Similar Properties Section */}

                    {/* <div className="similar-properties"   // Click event to navigate
                        style={{ cursor: "pointer" }} >
                        <h3>Similar Properties</h3>
                        {similarProperties.length > 0 ? (
                            <Slider {...{
                                dots: false,
                                infinite: true,
                                speed: 500,
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                responsive: [
                                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                                    { breakpoint: 768, settings: { slidesToShow: 1 } },
                                ],
                            }}>
                                {similarProperties.map((property) => (
                                    <div key={property.id} className="similar-property-card">
                                        <div className="similar-property-image">
                                            {property.media ? (
                                                property.media.startsWith("data:image") ? (
                                                    <img src={property.media} alt="Property" />
                                                ) : (
                                                    <video controls>
                                                        <source src={property.media} type="video/mp4" />
                                                    </video>
                                                )
                                            ) : (
                                                <p>No Image/Video Available</p>
                                            )}
                                        </div>
                                        <div className="similar-property-info">
                                            <h4>{property.proptype}</h4>
                                            <h6>ID: {property.postid}</h6>
                                            <p>Price: ₹{property.price}</p>
                                            <p><strong>Location:</strong> {property.pinlocality}, {property.city}</p>
                                        </div>
                                        <button className="btn btn-primary" onClick={() => handlePropertyClick(property.id, category)}> view</button>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <p>No Similar Properties Available</p>
                        )}
                    </div>*/}
                </div>

                {/* Right Section - Contact Seller */}
                <div className="property-contact">
                    <div className="neighborhood-alert">
                        <span>⚡ "Great locality with pleasant surroundings!</span>
                    </div>

                    <div className="contact-card">
                        <div className="agent-info">
                            <div className="agent-avatar">PP</div>
                            <div>
                                <h3 className="agent-name">{property.agent_name}</h3>
                                <p className="agent-role">Pincode Pillars Agent</p>
                                <p className="agent-phone">📞  {property.agent_phone || "90624..."}</p>
                            </div>
                        </div>

                        <h4 className="contact-title">Please share your contact</h4>

                        {/* Name Input */}
                        <input
                            type="text"
                            placeholder="Enter your name"
                            id="userName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="contact-input"
                        />

                        {/* Phone Input */}
                        <input
                            type="text"
                            placeholder="Enter Your Mobile number"
                            id="userPhone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="contact-input"
                        />

                        {/* Checkbox */}
                        <div className="contact-checkbox">
                            <Checkbox
                                checked={isChecked}
                                onChange={() => setIsChecked(!isChecked)}
                                color="primary"
                            />
                            <span>
                                I agree to be contacted by Pincode Pillars and agents via{" "}
                                <WhatsApp style={{ color: "#25D366", fontSize: "18px" }} /> WhatsApp,
                                SMS, phone, email etc.
                            </span>
                        </div>

                        {/* Contact Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="contact-button"
                            onClick={handleGetContactDetails}
                        >
                            Get Contact Details
                        </Button>
                    </div>

                    {/* Share Section */}
                    <div className="share-section">
                        {/* Share Button with WhatsApp */}
                        <button
                            onClick={() => {
                                const shareURL = window.location.href;
                                const whatsappURL = `https://wa.me/?text=${encodeURIComponent(
                                    "Check out this property! " + shareURL
                                )}`;
                                window.open(whatsappURL, "_blank");
                            }}
                            style={{
                                padding: "10px",
                                marginRight: "10px",
                                backgroundColor: isButtonEnabled ? "#25D366" : "#ccc",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: isButtonEnabled ? "pointer" : "not-allowed",
                                fontSize: "12px"
                            }}

                        >
                            🔗 Share on WhatsApp
                        </button>

                        {/* Copy Link Button */}
                        <button
                            onClick={copyLink}
                            disabled={!isButtonEnabled}
                            style={{
                                padding: "10px",
                                backgroundColor: isButtonEnabled ? "#1976d2" : "#ccc",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: isButtonEnabled ? "pointer" : "not-allowed",
                                fontSize: "12px"
                            }}
                        >
                            🔗 Copy Link
                        </button>

                    </div>
                </div>

            </div>

            {/* Popup Component using MUI Dialog */}
            <Dialog open={popupOpen} onClose={closePopup} maxWidth="md" fullWidth>
                <DialogTitle>
                    <span>Property Media</span>
                    <IconButton style={{ float: "right" }} onClick={closePopup}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {popupMedia.type === "video" ? (
                        <video controls autoPlay style={{ width: "100%" }}>
                            <source src={popupMedia.url} type="video/mp4" />
                        </video>
                    ) : (
                        <img src={popupMedia.url} alt="Property" style={{ width: "100%" }} />
                    )}
                    <Paper className="popup-property-info" style={{ padding: "10px", marginTop: "10px" }}>
                        <h3>{property.proptype} - {property.proptypename}</h3>
                        <p><strong>Location:</strong> {property.pinlocality}, {property.city}</p>
                        <p><strong>Price:</strong> ₹{property.cost}</p>
                        <p><strong>Area:</strong> {property.buitupareasq} sqft</p>
                    </Paper>
                </DialogContent>
            </Dialog>

        </div>
    );
};

export default PropertyDetails;


// SELECT suitablefor,addamenities,zonetype FROM firstproject.commercialpost;
